import AOS from 'aos';
import 'aos/dist/aos.css'; // You can a
 const initAOS = () => {
AOS.init();
}

export default initAOS